import "./style.css";
import { useRef, useEffect } from "react";

export const ConferenceTreeSlider = () => {
  const trackRef = useRef(null);
  const isDown = useRef(false);
  const isPaused = useRef(false); 

  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const images = require.context(
    "../../assets/images/conferenceTree",
    false,
    /\.(png|jpe?g|svg)$/
  );

  const imagesList = images.keys().map(images);

  useEffect(() => {
    const el = trackRef.current;
    let speed = 0.2;

    const animate = () => {
      if (!el) return;

      if (!isPaused.current && !isDown.current) {
        el.scrollLeft += speed;

        if (el.scrollLeft >= el.scrollWidth / 2) {
          el.scrollLeft = 0;
        }
      }

      requestAnimationFrame(animate);
    };

    animate();
  }, []);

  const handleMouseDown = (e) => {
    isDown.current = true;

    startX.current = e.pageX - trackRef.current.offsetLeft;
    scrollLeft.current = trackRef.current.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDown.current = false;
  };

  const handleMouseUp = () => {
    isDown.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDown.current) return;

    e.preventDefault();

    const x = e.pageX - trackRef.current.offsetLeft;
    const walk = (x - startX.current) * 2;

    trackRef.current.scrollLeft = scrollLeft.current - walk;
  };

  const handleMouseEnter = () => {
    isPaused.current = true;
  };

  const handleMouseLeaveSlider = () => {
    isPaused.current = false;
    isDown.current = false;
  };

  return (
    <div
      className="conference_slider"
      ref={trackRef}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeaveSlider}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}   
    >
      <div className="conference_slider_track">
        {[...imagesList, ...imagesList].map((img, index) => (
          <div className="conference_slide" key={index}>
            <img src={img} alt={`conference-${index}`} draggable="false" />
          </div>
        ))}
      </div>
    </div>
  );
};